import {
    // PRINTING_PRESS_PARTICULARS,
    // PRINTING_PRESS_OPERATING_ADDRESS,
    // SUPPORTING_DOCUMENTS
    LICENCE_DETAILS
} from 'common/application.const/Licence/MyLicence/PPLLicence';
import { formatDateTime } from 'utils/application.helpers';
// import { attachmentPayloadSetting, attachmentRetrieve, requestLicenceAttachment } from 'features/applicationPage/helpers';

export const formatPPL = async (licenceDetails: any, caseTypeID: string, application?: string) => {
    let licence;
    // let newDocs;
    // let newPayload;
    // let docsLic;

    // newDocs = [];
    // for (const key in licenceDetails.LICSupportingDoc) {
    //     if (licenceDetails.LICSupportingDoc.hasOwnProperty(key)) {
    //         const doc = await requestLicenceAttachment(licenceDetails.LICSupportingDoc[key], caseTypeID);
    //         if (doc.ID) {
    //             const attachment = {
    //                 ID: doc.ID,
    //                 fileName: doc.fileName,
    //                 mimeType: doc.mimeType,
    //                 category: doc.category
    //             };
    //             newDocs.push(attachment);
    //         }
    //     }
    // }

    // for (const key in licenceDetails.supportingDocuments) {
    //     if (licenceDetails.supportingDocuments.hasOwnProperty(key)) {
    //         const doc = await requestLicenceAttachment(licenceDetails.supportingDocuments[key], caseTypeID);
    //         if (doc.ID) {
    //             const attachment = {
    //                 ID: doc.ID,
    //                 fileName: doc.fileName,
    //                 mimeType: doc.mimeType,
    //                 category: doc.category
    //             };
    //             newDocs.push(attachment);
    //         }
    //     }
    // }

    // newPayload = attachmentPayloadSetting(newDocs);
    // docsLic = attachmentRetrieve(newPayload);

    
    const expiryDate = licenceDetails?.BusinessStatus === 'Cancelled' ? 'NA' : formatDateTime(licenceDetails?.ExpirationDate ?? '', true);

    licence = {
        id: 'printing-press-licence',
        formID: 'printing-press-licence',
        hasError: true,
        title: application?.startsWith('IMDA-IRIS-Work-LICApplication') ? 'Application Details' : 'Licence Details',
        values: {
            [`${LICENCE_DETAILS}-application-number`]: licenceDetails?.LICApplication?.general?.applicationNumber ?? '-',
            [`${LICENCE_DETAILS}-file-reference-number`]:
                licenceDetails?.LICApplication?.licence?.ApplicationCheckPg?.fileReferenceNumber ?? '-',
            [`${LICENCE_DETAILS}-status`]: licenceDetails?.BusinessStatus ?? licenceDetails?.CustomerStatus ?? '-',
            [`${LICENCE_DETAILS}-licence-number`]: licenceDetails?.LICApplication?.licence?.ApplicationCheckPg?.licenceNumber ?? '-',
            [`${LICENCE_DETAILS}-issue-date`]: formatDateTime(licenceDetails?.StartDate ?? '', true) ?? '-',
            [`${LICENCE_DETAILS}-expiry-date`]: expiryDate ?? '-'

            // [`${PRINTING_PRESS_PARTICULARS}-operating-address-is-the-same-as-acra-registered-address`]:
            //     licenceDetails?.printingPressParticulars?.operatingAddressIsTheSameAsAcraRegisteredAddress ?? '-',

            // [`${PRINTING_PRESS_OPERATING_ADDRESS}-name-of-printing-press`]: licenceDetails?.printingPressParticulars?.companyName ?? '-',
            // [`${PRINTING_PRESS_OPERATING_ADDRESS}-postal-code`]:
            //     licenceDetails?.printingPressParticularsOperatingAddress?.registeredAddress?.postalCode ?? '-',
            // [`${PRINTING_PRESS_OPERATING_ADDRESS}-block-house-no`]:
            //     licenceDetails?.printingPressParticularsOperatingAddress?.registeredAddress?.blockNo ?? '-',
            // [`${PRINTING_PRESS_OPERATING_ADDRESS}-street-name`]:
            //     licenceDetails?.printingPressParticularsOperatingAddress?.registeredAddress?.streetName ?? '-',
            // [`${PRINTING_PRESS_OPERATING_ADDRESS}-floor-level`]:
            //     licenceDetails?.printingPressParticularsOperatingAddress?.registeredAddress?.floor ?? '-',
            // [`${PRINTING_PRESS_OPERATING_ADDRESS}-unit`]:
            //     licenceDetails?.printingPressParticularsOperatingAddress?.registeredAddress?.unit ?? '-',
            // [`${PRINTING_PRESS_OPERATING_ADDRESS}-building-name`]:
            //     licenceDetails?.printingPressParticularsOperatingAddress?.registeredAddress?.buildingName ?? '-',
            // [`${PRINTING_PRESS_OPERATING_ADDRESS}-telephone-number`]:
            //     licenceDetails?.printingPressParticularsOfficeContact?.telephoneNumber ?? '-',
            // [`${PRINTING_PRESS_OPERATING_ADDRESS}-mobile-number`]:
            //     licenceDetails?.printingPressParticularsOfficeContact?.mobileNumber ?? '-',
            // [`${PRINTING_PRESS_OPERATING_ADDRESS}-number-of-machines`]: licenceDetails?.printingMachineParticulars?.noOfMachines ?? '-',

            // [`${SUPPORTING_DOCUMENTS}-supporting-documents`]: newDocs ? docsLic : undefined
        }
    };

    return licence;
};

const pplPayload = {
    formatPPL
};

export default pplPayload;
